import IpcRouter from '@shared/ipc/IpcRouter'
import type { ChallengeResult } from '@shared/challenge/types'

export interface ChallengeRunRequest {
  /** Caller-chosen id (any UUID) that `cancel` uses to name this run. */
  runId: string
  /**
   * Gateway-minted Arkose Data Exchange payload, when the caller could get one.
   * Where the gateway requires one, it refuses a token minted with null.
   */
  dataExchangeBlob: string | null
  /**
   * Mints a token ahead of the send. If Arkose wants a visible puzzle, the run
   * ends `puzzle-required` rather than open the window over the user's typing.
   */
  background?: boolean
  /**
   * The gateway refused a turn for want of a valid token, so run even with the
   * local flag off. The gateway only refuses when its own flag is on, so a
   * local `false` is stale.
   */
  gatewayRequiresToken?: boolean
}

export interface ChallengeIpcRouterType {
  /**
   * Run a bot-detection challenge and return a single-use token.
   *
   * Resolves with a typed failure rather than throwing. A challenge the user
   * abandons or that Arkose declines is an ordinary outcome, not an exception.
   */
  getToken(request: ChallengeRunRequest): Promise<ChallengeResult>

  /**
   * End the named run, e.g. because its turn was cancelled. Safe to call for a
   * run that has not started yet, has already finished, or was never sent.
   */
  cancel(request: { runId: string }): Promise<void>
}

class ChallengeIpcRouter extends IpcRouter<ChallengeIpcRouterType> {
  constructor() {
    super('challenge', {
      getToken: true,
      cancel: true,
    })
  }
}

export default ChallengeIpcRouter
